/**
 * @module services/coverage
 * @description Texto de cobertura (obra social · plan · N° de afiliado) para
 *              Agenda, "Cita asignada" y Atenciones. Se apoya en los helpers
 *              de `patient-utils.js` (member > medicalInsuranceObj > estructura
 *              vieja) y omite lo que falta en vez de mostrar "N/A".
 */
import {
  getMedicalInsuranceName,
  getMedicalInsurancePlan,
  getMedicalInsuranceNumber,
} from "@/services/patient-utils";

/**
 * @description Valor útil de un helper de patient-utils ("" si es "N/A").
 * @param {string} value
 * @returns {string}
 */
function clean(value) {
  if (!value || value === "N/A") return "";
  return String(value).trim();
}

/**
 * @description Cobertura del paciente en una línea. UC-REG-274.
 * @param {Object} patient - User paciente (con `patient` y opcional `member`)
 * @returns {string} p. ej. "OSDE · Plan 210 · N° 12345678", o "" si no tiene
 */
export function formatCoverage(patient) {
  if (!patient) return "";
  const name = clean(getMedicalInsuranceName(patient));
  const plan = clean(getMedicalInsurancePlan(patient));
  const number = clean(getMedicalInsuranceNumber(patient));
  return [name, plan && `Plan ${plan}`, number && `N° ${number}`]
    .filter(Boolean)
    .join(" · ");
}

/**
 * @description Cobertura del renglón de Atenciones (`ScheduleView.vue`).
 *              UC-REG-274: antes no mostraba nada si faltaba el plan, nunca
 *              mostraba la obra social y con cobertura externa mostraba el ID
 *              de la obra social como número de afiliado. Ahora es el mismo
 *              texto que Agenda / "Cita asignada".
 * @param {Object} patient
 * @returns {string}
 */
export function formatScheduleCoverage(patient) {
  return formatCoverage(patient);
}
